export default "__VITE_ASSET__hbuY8aI___"